import React from 'react';
import { motion } from 'framer-motion';
import ing1 from '../../assets/reviewimg/img1.jpg'
import ing2 from '../../assets/reviewimg/img2.jpg'
import ing3 from '../../assets/reviewimg/img3.jpg'



const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.8 },
    visible: { opacity: 1, y: 0, scale: 1, rotate: [0, 10, -10, 0], transition: { duration: 0.6 } },
};

const hoverVariants = {
    scale: 1.05,
    rotate: 2,
    backgroundColor: '#f0f0f0',
    transition: {
        yoyo: Infinity, // Repeat the animation
        duration: 0.4,
    },
};

function BusinessReviews() {
    return (
        <section>
            <div className="py-5 max-w-7xl mx-auto">
                <div className="flex flex-col items-center justify-center w-full p-6 mx-auto text-center xl:px-0">
                    <div className="text-md font-bold tracking-wider text-gray-700 uppercase">Testimonials</div>
                    <h2 className="max-w-2xl mt-3 text-2xl font-bold leading-snug tracking-tight text-blue-600 lg:leading-tight lg:text-3xl dark:text-white">Here's what our users said</h2>
                    <p className="max-w-2xl py-4 text-lg leading-normal text-gray-500 lg:text-xl xl:text-xl">Testimonials is a great way to increase brand trust and awareness. Use this section to highlight your popular customers.</p>
                </div>
                <motion.div
                    className="container p-6 mx-auto mb-10 xl:px-0"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <div className="grid gap-10 lg:grid-cols-2 xl:grid-cols-3">
                        {[
                            {
                                text: 'Share a testimonial that hits some of your benefits from one of your popular customers.',
                                name: 'Anaya Sharma',
                                position: 'Teacher',
                            
                                // image: 'https://images.unsplash.com/photo-1511485977113-f34c92461ad9?crop=faces&cs=tinysrgb&fit=crop&fm=jpg&ixid=MnwxfDB8MXxhbGx8fHx8fHx8fHwxNjIwMTQ5ODEx&ixlib=rb-1.2.1&q=80&w=100&h=100',
                                image:ing1
                            },
                            {
                                text: 'Make sure you only pick the right sentence to keep it short and simple.',
                                name: 'Nikita roy',
                                position: 'Professor',
                                image:ing2
                                // image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&crop=faces&fit=crop&w=100&h=100&q=80',
                            },
                            {
                                text: "This is an awesome landing page template I've seen. I would use this for anything.",
                                name: 'Vivek sharma',
                                position: 'Teacher',
                                image:ing3
                                // image: 'https://images.unsplash.com/photo-1624224971170-2f84fed5eb5e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=100&h=100&crop=faces&q=80',
                            },
                        ].map((testimonial, index) => (
                            <motion.div
                                key={index}
                                className="flex flex-col justify-between w-full h-full px-6 py-6 bg-gray-100 dark:bg-gray-800 md:px-14 rounded-2xl md:py-14 dark:bg-trueGray-800"
                                variants={itemVariants}
                                whileHover={hoverVariants}
                            >
                                <p className="text-2xl leading-normal dark:text-gray-300">
                                    {testimonial.text}
                                </p>
                                <div className="flex items-center mt-8 space-x-3">
                                    <div className="flex-shrink-0 overflow-hidden rounded-full w-14 h-14">
                                        <img alt="Avatar" src={testimonial.image} loading="lazy" />
                                    </div>
                                    <div>
                                        <div className="text-lg font-medium ">{testimonial.name}</div>
                                        <div className="text-gray-600 dark:text-gray-400">{testimonial.position}</div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}

export default BusinessReviews;
